import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=74023308&scoped=true&"
import script from "./detail.js?vue&type=script&lang=js&"
export * from "./detail.js?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=74023308&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74023308",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74023308')) {
      api.createRecord('74023308', component.options)
    } else {
      api.reload('74023308', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=74023308&scoped=true&", function () {
      api.rerender('74023308', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/seller/components/groupBuying/detail.vue"
export default component.exports